import { Walls } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { oneEightyDeg, pipi } from '../../../store/baseValues'
import { getAngle2D } from '../../generalMaths/geometry'

export function dragFromLeftVertex(item: Walls, xE: number, zE: number) {
  const start = item?.end
  if (!start) return { x: 0, z: 0, rotation: 0, width: 0, start: [0, 0] }
  const { angle } = getAngle2D(start, [xE, zE]) //This should be the same vector as when drawing line.
  const width = toVector3([start[0], 0, start[1]]).distanceTo(toVector3([xE, 0, zE]))
  const thickness = item.thickness / 2
  return {
    x: (start[0] + xE) / 2 - thickness * Math.sin(angle),
    z: (start[1] + zE) / 2 + thickness * Math.cos(angle),
    rotation: angle < oneEightyDeg ? -pipi + angle + oneEightyDeg : angle + oneEightyDeg,
    width,
    start: [xE, zE] satisfies [number, number],
  }
}
